var _desc, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "55px",
    viewBox: "0 0 115 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/BLUE BUTTON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "BLUE-BUTTON",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0060869,6.03527338 C45.9131884,6.44038069 17.1921142,3.79190124 5.06415198,13.8178947 C0.70944956,17.4178579 -0.471600769,28.8768902 0.157408379,36.1119265 C1.86870794,48.3876717 18.4804455,49.7702557 32.9705019,50.4324846 C51.3610109,51.2729733 70.7237777,51.1004704 84.6099376,50.4324846 C99.4929306,48.9699948 111.211256,48.9699948 110.997111,29.4952615 C110.947097,24.9469096 110.793894,19.3957662 107.330879,15.3347677 C98.4773387,7.11802143 81.1438778,6.28576802 67.0060869,6.03527338 Z",
    id: "SHADOW",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0060869,0.0352733755 C45.9131884,0.440380687 17.1921142,-2.20809876 5.06415198,7.81789471 C0.70944956,11.4178579 -0.471600769,22.8768902 0.157408379,30.1119265 C1.86870794,42.3876717 18.4804455,43.7702557 32.9705019,44.4324846 C51.3610109,45.2729733 70.7237777,45.1004704 84.6099376,44.4324846 C99.4929306,42.9699948 111.211256,42.9699948 110.997111,23.4952615 C110.947097,18.9469096 110.793894,13.3957662 107.330879,9.33476765 C98.4773387,1.11802143 81.1438778,0.285768021 67.0060869,0.0352733755 Z",
    id: "STROKE_99fb390a-b112-4495-90fb-e96524237ba6",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#2880B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,37.4864435 C28.4892555,40.2380932 87.6851613,41.6815984 100.209195,36.7114765 C106.322296,34.2855124 107.288733,23.2115507 104.54143,15",
    id: "Path",
    stroke: "#1F6389",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100,11.2475627 C91.7775772,5.99474425 71.1956703,5.18092618 60.1282456,5.11899576 C43.970647,4.84163265 34.5330105,4.80714026 18.9481776,7.81774183 C10.7652391,9.89392592 6.67353641,12.8178884 5.5972802,20.4835996 C4.52102399,28.1493107 4.4606847,32.1699379 9.20988427,35",
    id: "Path",
    stroke: "#3B9CD3",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueButton);
export default __webpack_public_path__ + "static/media/blueButton.b8f3f96f079e7fc6bf7459ee503ee834.svg";
export { ForwardRef as ReactComponent };